import { render } from "./SavingIcon.vue?vue&type=template&id=d9c4f4b0"
import script from "./SavingIcon.vue?vue&type=script&lang=js"
export * from "./SavingIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__